import { titleCase } from 'title-case'
import { useSnapshot } from 'valtio'
import { options } from '../optionsStorage'
import { OptionsGroupType, guiOptionsScheme } from '../optionsGuiScheme'
import { optionsMeta } from '../defaultOptions'
import OptionsItems, { OptionMeta } from './OptionsItems'
import ReplaySettingsScreen from './ReplaySettingsScreen'
import Button from './Button'
import { showInputsModal } from './SelectOption'

const StringOptionEditor = ({ optionKey, text }: { optionKey: string, text: string }) => {
  const value = useSnapshot(options)[optionKey] as string
  return <Button
    inScreen
    label={`${text}: ${value}`}
    onClick={async () => {
      const result = await showInputsModal(text, {
        value: {
          type: 'text',
          defaultValue: value,
        },
      })
      if (!result) return
      options[optionKey] = result.value
    }}
  />
}

export const optionValueToType = (optionValue: any, optionKey: string) => {
  // Check if option has possible values in optionsMeta (enum = toggle)
  const meta = optionsMeta[optionKey as keyof typeof optionsMeta]
  if (typeof optionValue === 'boolean' || (meta?.possibleValues && meta.possibleValues.length > 0)) return 'toggle'
  if (typeof optionValue === 'number') return 'slider'
  if (typeof optionValue === 'string') return 'element'
}

const finalItemsScheme: Record<keyof typeof guiOptionsScheme, OptionMeta[]> = Object.fromEntries(Object.entries(guiOptionsScheme).map(([groupName, optionsArr]) => {
  return [groupName, optionsArr.flatMap((optionsObj) => {
    return Object.entries(optionsObj).map(([optionKey, metaMerge]) => {
      const optionValue = options[optionKey]

      const type = optionValueToType(optionValue, optionKey)
      const meta: OptionMeta = {
        id: optionKey === 'custom' ? undefined : optionKey,
        type,
        // todo I don't like the whole idea of custom. Why it is even here?
        ...optionKey === 'custom' ? {
          type: 'element',
          render: metaMerge
        } : {
          ...(type === 'element' && !('render' in (metaMerge as any)) ? {
            type: 'element',
            render: () => <StringOptionEditor optionKey={optionKey} text={(metaMerge as any)?.text ?? optionKey} />
            ,
            ...(metaMerge as any),
          } : {
            ...metaMerge,
          })
        }
      }
      return meta
    })
  })]
}))

export default ({ group, backButtonAction }: { group: OptionsGroupType, backButtonAction? }) => {
  if (group === 'replay') {
    return <ReplaySettingsScreen backButtonAction={backButtonAction} />
  }

  const items = finalItemsScheme[group]
  const title = group === 'main' ? 'Settings' : `${titleCase(group)} Settings`
  return <OptionsItems items={items} title={title} backButtonAction={backButtonAction} />
}
